import { SagaCoreProvider, SagaSentryOptions } from "@einride/saga-core"
import { MantineProvider } from "@mantine/core"
import { Notifications } from "@mantine/notifications"
import { UserPreferencesProvider } from "components/UserPreferences/UserPreferencesContext"
import { ApolloProviderContext } from "lib/api/context/ApolloProviderContext"
import { AmplitudeExperimentProvider } from "lib/context/AmplitudeExperimentProvider/AmplitudeExperimentProvider"
import { getSagaMode } from "lib/env"
import { ErrorPage } from "pages/ErrorPage/ErrorPage"
import { ErrorBoundary } from "react-error-boundary"
import { Outlet } from "react-router-dom"
import { QueryParamProvider } from "use-query-params"
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6"

const sentryConfig: SagaSentryOptions = {
  activateSessionReplays: true,
  eventFilter: (event) => {
    if (
      event.message?.includes("Failed to fetch dynamically imported module") ||
      event.message?.includes("PermissionDenied") ||
      event.message?.includes("ResizeObserver loop limit exceeded")
    ) {
      return null
    }
    return event
  },
}

export const RootLayout = (): React.JSX.Element => {
  return (
    <QueryParamProvider adapter={ReactRouter6Adapter} options={{ enableBatching: true }}>
      <MantineProvider withGlobalStyles withNormalizeCSS>
        <SagaCoreProvider mode={getSagaMode()} app="EXPLORE" sentryProviderOptions={sentryConfig}>
          <UserPreferencesProvider>
            <ErrorBoundary FallbackComponent={ErrorPage}>
              <ApolloProviderContext>
                <AmplitudeExperimentProvider>
                  <Notifications position="top-center" />
                  <Outlet />
                </AmplitudeExperimentProvider>
              </ApolloProviderContext>
            </ErrorBoundary>
          </UserPreferencesProvider>
        </SagaCoreProvider>
      </MantineProvider>
    </QueryParamProvider>
  )
}
